import React from 'react';
import { Row, ProgressBar } from '../../ui-kit';
import { IconCalendarXmark } from '../../ui-kit/icons';
import { displayIntervals } from './timeline-helper';
import SkillIcon from '../../general/SkillIcon';
import { linkToNewDutyTransaction } from '../../../utils/dutyTransactions';
import IntervalInformationPopup from './IntervalInformationPopup';
import moment from 'moment';

const MiniTimeline = ({ intervals, periodStartTime, periodEndTime }) => {
  return (
    <div style={{ width: '90%', margin: '0 5%' }}>
      <ProgressBar className={'timeline mini'}>
        {displayIntervals(intervals || [], periodStartTime, periodEndTime)}
      </ProgressBar>
    </div>
  );
};

const FunctionList = props => {
  if (props.functions.length === 0)
    return (
      <div style={{ width: '90%', margin: '0px 5%', whiteSpace: 'normal' }}>
        <small>{I18n.t('duty_planner.no_assignable_functions')}</small>
      </div>
    );

  return (
    <>
      <strong>{I18n.t('duty_planner.click_to_assign')}</strong>
      {props.functions.map(f => (
        <div
          className="clickable-inner-item"
          key={f.id}
          onClick={() => props.assignToFunction(f.id, props.user, false)}
        >
          <SkillIcon skill={f} />
          {f.name}
        </div>
      ))}
      <br />
    </>
  );
};

class CandidateContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      displayActionList: false
    };
  }

  canUserPerformFunction = (func, user) => {
    const functionSkillId = func.skill_id;
    if (!functionSkillId) return true;
    return user.intervals.some(i => (i.skill_ids || []).includes(functionSkillId));
  };

  performableFunctions = user => {
    if (!this.props.functions) return [];
    return this.props.functions.filter(f => this.canUserPerformFunction(f, user));
  };

  assignToFunction = (functionId, user, clearGaps) => {
    this.props.assign(functionId, user, clearGaps);
  };

  toggleFunctionList = e => {
    // The following lines prevents the function list to toggle if the event target
    // is a duty transaction link.
    const target = e.target;
    if (target.id === 'duty_transaction_link') return;
    this.setState(oldState => ({
      displayActionList: !oldState.displayActionList
    }));
  };

  convertToCandidate = () => {
    this.props.assign(null, this.props.user);
  };

  render = () => {
    const { user, periodStartTime, periodEndTime, isCandidate } = this.props;
    const onClickAction = isCandidate ? this.toggleFunctionList : this.convertToCandidate;
    const newAbsenceLink = linkToNewDutyTransaction('absence_requests', user.membershipId, {
      start_time: moment(periodStartTime).format(),
      end_time: moment(periodEndTime).format()
    });
    return (
      <>
        <div className="list-group-item list-group-item-action" onClick={event => onClickAction(event)}>
          <div>
            <span>{user.nickname}</span>{' '}
            <IntervalInformationPopup
              overlayPlacement={'right'}
              intervals={user.intervals}
              dutyTransactions={user.dutyTransactions}
            />
          </div>
          <Row>
            {isCandidate && (
              <MiniTimeline
                intervals={user.intervals}
                periodStartTime={periodStartTime}
                periodEndTime={periodEndTime}
              />
            )}
            {this.state.displayActionList && (
              <>
                <FunctionList
                  functions={this.performableFunctions(user)}
                  user={user}
                  assignToFunction={this.assignToFunction}
                />
                <div className="clickable-inner-item">
                  <a href={newAbsenceLink} target={'_blank'} rel="noreferrer">
                    <IconCalendarXmark /> {I18n.t('schedules.exchanges.absence_request.new')}
                  </a>
                </div>
              </>
            )}
          </Row>
        </div>
      </>
    );
  };
}
export default CandidateContainer;
